import $ from "jquery";

const STRATEGIES = {
  ON_CHANGE: 0,
  WHEN_EQ: 1,
};

class DependentField {
  constructor(el) {
    this.$el = $(el);
    this.$depFieldEl = $(this.$el.data("dependentField"));
    if (this.$depFieldEl.data("dependentFieldOnChange")) {
      this.strategy = STRATEGIES.ON_CHANGE;
      this.originalVal = this.$depFieldEl.val();
      // run once to ensure proper initial state
      this._updateOnChange();
    } else {
      this.strategy = STRATEGIES.WHEN_EQ;
      this._updateWhenEq();
    }
    this._bindEvents();
  }

  _bindEvents() {
    this.$depFieldEl.on("input change", (event) => {
      event.preventDefault();
      if (this.strategy === STRATEGIES.ON_CHANGE) {
        this._updateOnChange();
      } else {
        this._updateWhenEq();
      }
    });
  }

  _updateWhenEq() {
    let whenEq = this.$depFieldEl.data("dependentFieldWhen");

    let curVal;
    if (this.$depFieldEl.attr("type") === "checkbox") {
      curVal = this.$depFieldEl.is(":checked");
    } else {
      curVal = this.$depFieldEl.val();
    }

    if (curVal === whenEq) {
      this.$el.show(200);
    } else {
      this.$el.hide(100);
    }
  }

  _updateOnChange() {
    let curVal = this.$depFieldEl.val();
    if (curVal === this.originalVal) {
      this.$el.hide(100);
    } else {
      this.$el.show(200);
    }
  }
}

$(() => {
  const $el = $("[data-dependent-field]");

  if ($el.length) {
    $el.hide();
    new DependentField($el);
  }
});
